import type { FC } from 'react';
import type { IconProps } from '@/types/icons';

export const SurferLogo: FC<IconProps> = ({
	height = 30,
	width = 78,
	...rest
}) => (
	<svg
		aria-hidden
		fill="currentColor"
		focusable={false}
		height={height}
		viewBox="0 0 78 30"
		width={width}
		xmlns="http://www.w3.org/2000/svg"
		{...rest}
	>
		<path d="M7.408 0c4.152 0 5.607 2.311 5.607 5.956v3.488H7.62V6.3c0-.778-.173-1.256-.848-1.256-.645 0-.847.467-.847 1.29v.744c0 1.178.24 1.922 1.223 2.978l2.89 2.977c2.553 2.667 3.333 4.7 3.333 7.834v1.444c0 4.5-1.907 7.6-6.252 7.6H5.886C2.004 29.922 0 27.733 0 23.5v-4.656h5.51v4.034c0 .978.241 1.522.954 1.522.684 0 .915-.589.915-1.722V21.9c0-1.689-.106-2.389-1.33-3.678l-2.928-3.01c-2.11-2.156-2.89-4.545-2.89-7.523V6.3C.241 2.467 2.245 0 6.156 0h1.252ZM13.795.389h5.78v21.889c0 .978.309 1.489.916 1.489.684 0 .915-.545.915-1.49V.39h5.78V22.6c0 4.422-2.206 7.4-6.185 7.4h-1.088c-4.22 0-6.118-2.933-6.118-7.4V.389ZM33.448 29.533H27.84V.39h8.805c2.486 0 4.181 1.689 4.181 5.133v3.834c0 2.7-1.223 3.91-2.206 4.422.954.433 2.206 1.61 2.206 3.8v9.644c0 1.1.174 1.722.337 2.111v.2h-5.539c-.24-.355-.443-1.022-.443-2.077V19c0-.978-.202-1.411-.954-1.411h-.78v11.944Zm0-17.433h.713c.713 0 1.021-.389 1.021-1.411V6.778c0-1.022-.173-1.367-.915-1.367h-.82V12.1ZM41.57.389h10.577v5.989h-5.029v5.01h3.873v6.145h-3.873v11.99h-5.54V.388h-.009ZM63.1.389v6.033H58.14V11.4h3.979v6.189h-3.98v5.8h5.165v6.144H52.6V.39h10.5ZM69.352 29.533h-5.606V.39h8.805c2.485 0 4.18 1.689 4.18 5.133v3.834c0 2.7-1.223 3.91-2.205 4.422.953.433 2.206 1.61 2.206 3.8v9.644c0 1.1.173 1.722.337 2.111v.2h-5.54c-.24-.355-.442-1.022-.442-2.077V19c0-.978-.203-1.411-.954-1.411h-.78v11.944Zm0-17.433h.713c.713 0 1.022-.389 1.022-1.411V6.778c0-1.022-.174-1.367-.916-1.367h-.819V12.1Z" />
	</svg>
);
